import clsx from "clsx";
import type { HTMLAttributes, MouseEventHandler } from "react";
import type { ThemeColor } from "../../../lib/FrontendTypes";
import "./Chip.css";
export interface ChipProps extends Omit<HTMLAttributes<HTMLSpanElement>, "onClick"> {
  color?: ThemeColor | "schema-array" | "schema-object" | "schema-any" | "schema-enum";
  /** Makes the chip a toggle button, such as a quick filter. */
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /** Whether a clickable chip's toggle is on. */
  pressed?: boolean;
}
export default function Chip({
  children,
  className,
  color = "primary",
  onClick,
  pressed,
  ...props
}: ChipProps) {
  const shared = { "data-color": color, className: clsx("calmlens-chip", className) };
  return onClick ? (
    <button
      {...(props as HTMLAttributes<HTMLButtonElement>)}
      {...shared}
      type="button"
      aria-pressed={pressed ?? false}
      onClick={onClick}
    >
      {children}
    </button>
  ) : (
    <span {...props} {...shared}>
      {children}
    </span>
  );
}
